import React from 'react'
import ConnectorInfo from './SubComponents/ConnectorInfo'
import BusinessEntities from './BusinessEntities/BusinessEntities'
import NoData from '../../../../../Alerts/WarningComponent/NoEntities'
import { describeConnection } from '../../../../../../features/connections/connectionsApi'
const uniqueEntityCount = (source, target) => new Set(source.concat(target).map((entity) => entity.entityName)).size
const SelectedConnector = ({ connection, businessEntitiesSource, businessEntitiesTarget }) => {
    const connector = describeConnection(connection)
    const entityCount = uniqueEntityCount(businessEntitiesSource, businessEntitiesTarget)

    return (
        <div className="text-muted mt-4 mt-md-0">
            <div className="card no-border no-boxshadow mb-0">
                <div className="card-header card-titlenew">
                    <span className="float-left">{connector.displayName}</span>
                    <span className="clearfix"></span>
                </div>
                <div className="card-body padding-btm-0">
                    <ConnectorInfo
                        sourceName={connector.source.name}
                        sourceVersion={connector.source.version}
                        targetName={connector.target.name}
                        targetVersion={connector.target.version}
                        featureName={connector.featureName}
                    />
                    <BusinessEntities
                        connector={connector}
                        businessEntitiesSource={businessEntitiesSource}
                        businessEntitiesTarget={businessEntitiesTarget}
                        entityCount={entityCount}
                    />
                    {connector.isSetupCompleted && entityCount === 0 ? <NoData /> : null}
                </div>
            </div>
        </div>
    )
}

export default SelectedConnector
